var required = "required";
var optional = "optional";
var today = "Today";
var Search = "Search";
var Expand = "Expand";
var Year = "Year";
var Month = "Month";
var Help = "Help";
var Success = "Success";
var Warning = "Warning";
var Upload = "Upload";
var Remove = "Remove";
var Cancel = "Cancel";
var On = "On";
var Off = "Off";
var Clear = "Clear";
var enUS = {
	required: required,
	optional: optional,
	today: today,
	"next-month": "Next month",
	"previous-month": "Previous month",
	"No results": "No results",
	"No results for <q>{search}</q>": "No results for <q>{search}</q>",
	Search: Search,
	Expand: Expand,
	"Searching...": "Searching...",
	"Searching for <q>{search}</q>": "Searching for <q>{search}</q>",
	"There was a problem completing your search": "There was a problem completing your search",
	"Try again": "Try again",
	"{count} selected": "{count} selected",
	Year: Year,
	Month: Month,
	"Start year": "Start year",
	"Start month": "Start month",
	"End year": "End year",
	"End month": "End month",
	"Select all": "Select all",
	Help: Help,
	Success: Success,
	Warning: Warning,
	"Error": "Error",
	Upload: Upload,
	Remove: Remove,
	"Choose file": "Choose file",
	"Drag and drop here or <q>choose {maxFiles, plural, one {file} other {files}}</q>.": "Drag and drop here or <q>choose {maxFiles, plural, one {file} other {files}}</q>.",
	"No file chosen.": "No file chosen.",
	"{files, plural, one {1 file} other {# files}} chosen": "{files, plural, one {1 file} other {# files}} chosen",
	"Add up to {maxFiles, plural, one {1 file} other {# files}}.": "Add up to {maxFiles, plural, one {1 file} other {# files}}.",
	"Max file size: {size}.": "Max file size: {size}.",
	"Accepts {list} file types.": "Accepts {list} file types.",
	Cancel: Cancel,
	"Send message": "Send message",
	On: On,
	Off: Off,
	Clear: Clear,
	"Select date": "Select date"
};

export { Cancel, Clear, Expand, Help, Month, Off, On, Remove, Search, Success, Upload, Warning, Year, enUS as default, optional, required, today };
